import PackageJson from "../../package.json";

export const name = PackageJson.name;
export const version = PackageJson.version;

// Production Server
let _url = "https://api.scft.ir";
// let _url = "http://172.10.10.197:8000";1
// let _url = "http://192.168.11.158:8000";
if (window.location.host === "dev.scft.ir") {
_url = "https://dev.api.scft.ir";

}
export const baseURL = _url;

// Dev Server
// export const baseURL = "http://127.0.0.1:8000";
// export const baseURL = "http://192.168.43.173:8000";
// export const baseURL = "https://api.staging.t2bon.com";
